import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import { getDropdown } from '../native/Dropdown';
import { getFormInput } from '../native/Input';
import { getButton } from '../native/Button';
import { getDBFormattedDate } from '../utilities/Data';
import styles from '../styles/Styles';

import ic_cancel from '../images/cancel_a.png';

function changeValueText(context, text) {
  let temp = context.state.filter;
  temp[temp.selected.id].value = text;
  context.setState({ filter : temp });
}

function changeValueTime(context, value) {
  let temp = context.state.filter;
  temp[temp.selected.id].fr_value_start = value[0];
  temp[temp.selected.id].fr_value_end = value[1];
  temp[temp.selected.id].value_start = getDBFormattedDate(value[0]);
  temp[temp.selected.id].value_end = getDBFormattedDate(value[1]);
  context.setState({ filter : temp });
}

function getFilterView(context) {
  if (['input_text', 'input_free_text'].includes(context.state.filter[context.state.filter.selected.id].type)) {
    return (
      <div>
        <div style={{marginTop : 10}}><span className='crs_default fnt_blk_a txt_14 txt_bold'>Kata Kunci</span></div>
        { getFormInput({value : context.state.filter[context.state.filter.selected.id].value, inner_style : styles.blk_bt_brd_a, text_class : 'fnt_blk_a txt_14', input_type : 'text', outer_style : {marginTop : 5}}, (text) => changeValueText(context, text)) }
      </div>
    );
  } else if (context.state.filter[context.state.filter.selected.id].type === 'time_range') {
    return (
      <div>
        <div style={{marginTop : 10}}><span className='crs_default fnt_blk_a txt_14 txt_bold'>Pilih Tanggal</span></div>
        <div className='txt_12 fnt_blk_a' style={{...styles.blk_bt_brd_a, ...{marginTop : 5, padding : '0 10px', height : 40, display : 'flex', alignItems : 'center'}}}>
          <DateRangePicker
            rangeDivider='to'
            locale='id-ID'
            calendarIcon={null}
            clearIcon={null}
            returnValue='range'
            format='dd-MM-y'
            showLeadingZeros={true}
            onChange={(value) => changeValueTime(context, value)}
            value={[context.state.filter[context.state.filter.selected.id].fr_value_start, context.state.filter[context.state.filter.selected.id].fr_value_end]}
          />
        </div>
      </div>
    );
  } else if (context.state.filter[context.state.filter.selected.id].type === 'dropdown') {
    return (
      <div>
        <div style={{marginTop : 10}}><span className='crs_default fnt_blk_a txt_14 txt_bold'>Pilihan</span></div>
        { getDropdown({data : context.state.filter[context.state.filter.selected.id], outer_style : {...styles.blk_bt_brd_a, ...{marginTop : 5}}}, (pos) => changeChooser(context, pos)) }
      </div>
    );
  }
}

function changeChooser(context, pos) {
  let temp = context.state.filter;
  temp[context.state.filter.selected.id].selected = temp[context.state.filter.selected.id].data[pos];
  context.setState({ filter : temp });
}

function changeFilter(context, pos) {
  let temp = context.state.filter;
  temp.selected = temp.data[pos];
  context.setState({ filter : temp });
}

export function showFilter(context, closeListener) {
  if (closeListener === undefined) { closeListener = null; }
  if (context.state.filter === undefined) { context.state.filter = null; }
  if (context.state.filter !== null) {
    let temp = context.state.filter;
    temp.is_show = !temp.is_show;
    context.setState({ filter : temp }, () => {
      if (!temp.is_show) {
        // WHEN IS_SHOW = FALSE
        if (closeListener !== null) { closeListener(); }
      }
    });
  }
}

function getAction(context, listener) {
  showFilter(context, () => {
    if (listener !== null) { listener(); }
  });
}

export function showFilterDialog(context, listener) {
  if (context.state.filter === undefined) { context.state.filter = null; }
  if (listener === undefined) { listener = null; }
  if (context.state.filter !== null) {
    if (context.state.filter.is_show) {
      return (
        <div onClick={() => showFilter(context)} style={m_style.root_dialog} >
          <div onClick={(e) => e.stopPropagation()} style={m_style.dialog_container}>
            <div onClick={() => showFilter(context)} className='crs_pointer view_center' style={{position : 'absolute', right : -24, top : -34, width : 24, height : 24, background : 'red', borderRadius : '50%'}}>
              <img alt='' style={{width : 10}} src={ic_cancel}/>
            </div>
            <div style={{padding : 20}}>
              <div><span className='crs_default fnt_blk_a txt_14 txt_bold'>Filter By</span></div>
              { getDropdown({data : context.state.filter, outer_style : {...styles.blk_bt_brd_a, ...{marginTop : 5}}}, (pos) => changeFilter(context, pos)) }

              { getFilterView(context) }

              { getButton({text : 'Cari', text_class : 'fnt_wht_a txt_14', outer_style : {marginTop : 20, alignItems : 'flex-end'}, inner_style : {...{width : 130, borderRadius : 10}, ...styles.ntv_bg_color_b}}, () => getAction(context, listener)) }
            </div>
          </div>
        </div>
      );
    }
  }
  return null;
}

const m_style = {
  root_dialog : {
    display : 'flex',
    flexDirection : 'column',
    position : 'fixed',
    overflow : 'auto',
    top : 0, left : 0,
    width : '100%',
    height : '100%',
    backgroundColor : 'rgba(0, 0, 0, 0.5)'
  },
  dialog_container : {
    position : 'relative',
    width : '80%',
    maxWidth : 300,
    backgroundColor : 'white',
    borderRadius : 10,
    margin : 'auto'
  }
}
